(function installBundleGiftCart() {
  if (window.__naluBundleGiftCart) return;
  window.__naluBundleGiftCart = true;

  const originalFetch = window.fetch.bind(window);
  window.fetch = function (input, init) {
    try {
      const url = typeof input === 'string' ? input : input?.url || '';
      if (init?.body instanceof FormData && /\/cart\/add(\.js)?([?#]|$)/.test(url)) {
        const nextBody = appendVisibleBundleGifts(init.body);
        if (nextBody !== init.body) init = Object.assign({}, init, { body: nextBody });
      }
    } catch (error) {
      console.error(error);
    }
    return originalFetch(input, init);
  };

  function appendVisibleBundleGifts(formData) {
    if ([...formData.keys()].some((key) => key.startsWith('items['))) return formData;

    const info = document.querySelector('product-info');
    if (!info || !info.querySelector('.nalu-wyg')) return formData;

    const pageProductId = info.dataset.productId || '';
    const bundleId = String(info.querySelector('product-form input[name="id"]')?.value || '');
    const mainId = String(formData.get('id') || '');
    if (!mainId || mainId !== bundleId) return formData;
    const gifts = [...info.querySelectorAll('.nalu-wyg__item[data-variant-id]')].filter((item) => {
      if (item.hidden || item.closest('[hidden]')) return false;
      if (!item.dataset.variantId) return false;
      if (pageProductId && item.dataset.productId === pageProductId) return false;
      if (String(item.dataset.variantId) === mainId) return false;
      return true;
    });
    if (!gifts.length || !mainId) return formData;

    const mainQty = parseInt(formData.get('quantity'), 10) || 1;
    const quantities = new Map();
    quantities.set(mainId, mainQty);
    gifts.forEach((item) => {
      const id = String(item.dataset.variantId);
      const qty = (parseInt(item.dataset.quantity, 10) || 1) * mainQty;
      quantities.set(id, (quantities.get(id) || 0) + qty);
    });

    const next = new FormData();
    let index = 0;
    quantities.forEach((quantity, id) => {
      next.append(`items[${index}][id]`, id);
      next.append(`items[${index}][quantity]`, String(quantity));
      index += 1;
    });

    ['sections', 'sections_url'].forEach((key) => {
      const value = formData.get(key);
      if (value) next.append(key, value);
    });
    return next;
  }
})();

if (!customElements.get('bundle-offer')) {
  customElements.define(
    'bundle-offer',
    class BundleOffer extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';

        this.variants = this.readJson('[data-bundle-variants]');
        this.addEventListener('click', (event) => this.onClick(event));
        this.alignWithForm();
      }

      readJson(selector) {
        try {
          return JSON.parse(this.querySelector(selector)?.textContent || '[]');
        } catch (error) {
          return [];
        }
      }

      onClick(event) {
        const swatch = event.target.closest('.nalu-bundle__swatch');
        if (swatch) {
          event.preventDefault();
          const card = swatch.closest('.nalu-bundle__card');
          const bed = swatch.closest('[data-bed]');
          if (!card || !bed) return;

          const colors = [...card.querySelectorAll('[data-bed]')].map((node) => node.dataset.current || '');
          colors[Number(bed.dataset.bed)] = swatch.dataset.color;
          const variant = this.findVariant(card.dataset.offer, colors);
          if (variant) this.applyVariant(variant, colors);
          return;
        }

        const head = event.target.closest('.nalu-bundle__card-head');
        if (!head) return;

        event.preventDefault();
        const card = head.closest('.nalu-bundle__card');
        if (!card || card.classList.contains('is-selected')) return;
        this.selectOffer(card.dataset.offer);
      }

      selectOffer(offer) {
        const sample = this.variants.find((variant) => variant.offer === offer);
        if (!sample) return;

        const current = this.currentColors();
        const size = sample.colors.length;
        const colors = current.slice(0, size);

        while (colors.length < size) {
          colors.push(colors[colors.length - 1] || sample.colors[colors.length] || sample.colors[0] || '');
        }

        const matched = colors.length ? this.findVariant(offer, colors) : null;
        const variant =
          matched ||
          this.variants.find((item) => item.offer === offer && item.available) ||
          this.variants.find((item) => item.offer === offer);

        if (variant) this.applyVariant(variant, matched ? colors : variant.colors);
      }

      currentColors() {
        const selected = this.querySelector('.nalu-bundle__card.is-selected');
        if (!selected) return [];
        return [...selected.querySelectorAll('[data-bed]')].map((node) => node.dataset.current || '');
      }

      findVariant(offer, colors) {
        const pool = this.variants.filter((variant) => variant.offer === offer);
        const available = pool.filter((variant) => variant.available);
        const source = available.length ? available : pool;
        const wanted = colors.map((color) => color.trim());
        const exact = source.find((variant) => variant.colors.map((color) => color.trim()).join(',') === wanted.join(','));
        if (exact) return exact;

        const sorted = [...wanted].map((color) => color.toLowerCase()).sort();
        return source.find((variant) => {
          const got = variant.colors.map((color) => color.trim().toLowerCase()).sort();
          return got.length === sorted.length && got.every((color, index) => color === sorted[index]);
        });
      }

      applyVariant(variant, colors) {
        const displayColors = colors && colors.length ? colors : variant.colors;
        const sameVariant = String(this.dataset.activeVariant) === String(variant.id);
        this.dataset.activeVariant = String(variant.id);
        this.render(variant, displayColors);
        if (!sameVariant) this.syncNative(variant);
      }

      render(variant, displayColors) {
        const colors = displayColors && displayColors.length ? displayColors : variant.colors;
        this.querySelectorAll('.nalu-bundle__card').forEach((card) => {
          const selected = card.dataset.offer === variant.offer;
          card.classList.toggle('is-selected', selected);
          card.querySelector('.nalu-bundle__card-head')?.setAttribute('aria-pressed', selected ? 'true' : 'false');

          const price = card.querySelector('[data-price]');
          const compare = card.querySelector('[data-compare]');

          if (!selected) {
            if (price && price.dataset.base) price.textContent = price.dataset.base;
            if (compare) {
              if (compare.dataset.base) {
                compare.hidden = false;
                compare.textContent = compare.dataset.base;
              } else {
                // compare.hidden = true;
              }
            }
            return;
          }

          if (price) price.textContent = variant.priceLabel;
          if (compare) {
            if (variant.compareLabel) {
              compare.hidden = false;
              compare.textContent = variant.compareLabel;
            } else if (compare.dataset.fallback) {
              compare.hidden = false;
              compare.textContent = compare.dataset.fallback;
            } else {
              // compare.hidden = true;
            }
          }

          card.querySelectorAll('[data-bed]').forEach((bed, index) => {
            const color = colors[index] || '';
            bed.dataset.current = color;
            const label = bed.querySelector('[data-color-label]');
            let hex = '';

            bed.querySelectorAll('.nalu-bundle__swatch').forEach((swatch) => {
              const match = swatch.dataset.color.trim().toLowerCase() === color.trim().toLowerCase();
              swatch.classList.toggle('is-selected', match);
              swatch.setAttribute('aria-pressed', match ? 'true' : 'false');
              if (match) hex = swatch.dataset.hex || '';
            });

            if (label) {
              label.textContent = color;
              label.style.color = hex;
            }
          });
        });

        this.updateWhatYouGet(variant);
      }

      updateWhatYouGet(variant) {
        const root = this.closest('product-info') || document;
        root.querySelectorAll('.nalu-wyg').forEach((box) => {
          box.querySelectorAll('[data-offers]').forEach((item) => {
            const allow = (item.dataset.offers || '').trim();
            if (!allow) {
              item.hidden = false;
              return;
            }
            const names = allow.split(',').map((name) => name.trim());
            item.hidden = !names.includes(variant.offer);
          });

          const yours = box.querySelector('[data-yours-price]');
          if (yours) yours.textContent = variant.priceLabel;

          const total = box.querySelector('[data-total-price]');
          if (total) {
            if (variant.compareLabel) {
              total.hidden = false;
              total.textContent = variant.compareLabel;
            } else {
              total.hidden = true;
              total.textContent = '';
            }
          }
        });
      }

      alignWithForm() {
        const selected = this.variants.find((variant) => String(variant.id) === String(this.dataset.activeVariant));
        if (!selected) return;
        const nativeId = this.nativeVariantId();
        if (nativeId && String(nativeId) === String(selected.id)) return;
        this.syncNative(selected);
      }

      nativeVariantId() {
        const root = this.closest('product-info') || document;
        return root.querySelector('product-form input[name="id"], form input[name="id"]')?.value || '';
      }

      syncNative(variant) {
        const root = this.closest('product-info') || document;
        root.querySelectorAll('input[name="id"]').forEach((input) => {
          input.value = variant.id;
        });

        const selects = root.querySelector('variant-selects');
        if (!selects) {
          this.keepVariantAddable(variant);
          return;
        }

        const ids = (variant.optionValueIds || []).filter(Boolean).map(String);
        let last = null;

        ids.forEach((id) => {
          const node = selects.querySelector(`[data-option-value-id="${CSS.escape(id)}"]`);
          if (!node) return;

          if (node.tagName === 'OPTION') {
            node.selected = true;
            const select = node.closest('select');
            if (select) {
              select.value = node.value;
              last = select;
            }
          } else {
            node.checked = true;
            last = node;
          }
        });

        last?.dispatchEvent(new Event('change', { bubbles: true }));
        this.keepVariantAddable(variant);
      }

      keepVariantAddable(variant) {
        const root = this.closest('product-info') || document;
        const restore = () => {
          root.querySelectorAll('product-form input[name="id"]').forEach((input) => {
            input.disabled = false;
            input.value = variant.id;
          });
          if (!variant.available) return;
          const button = root.querySelector('product-form [type="submit"]');
          if (!button) return;
          button.disabled = false;
          button.removeAttribute('disabled');
          button.removeAttribute('aria-disabled');
          const label = button.querySelector('span');
          if (label && window.variantStrings?.addToCart) label.textContent = window.variantStrings.addToCart;
        };

        restore();
        setTimeout(restore, 0);
        if (typeof subscribe === 'function' && window.PUB_SUB_EVENTS?.variantChange) {
          const unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, () => {
            restore();
            unsubscribe();
          });
        }
      }
    }
  );
}
